module.exports = __webpack_public_path__ + "img/blue_whiteBackground_Text_WEB.bdb9600b.jpg";